import { Component, OnInit } from '@angular/core';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { UtilsService } from "../utils/utils.service";
import { ModalSimpleComponent } from "../modal-simple/modal-simple.component";
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  listMode: boolean = false;
  privatePage: boolean = false;
  linkWebsite: string = '';
  currentYear: number = new Date().getFullYear();
  catalogueProperties: any = {};

  constructor(public catalogueService: CatalogueService, private modalService: NgbModal, private utilsService: UtilsService, private translateService: TranslateService) { }


  getCurrentLang() {
    return this.translateService.currentLang;
  }

  /**
   * Añade https:// a la URL si no tiene protocolo
   * @param url URL original
   * @returns URL con protocolo
   */
  fixUrl(url: string): string {
    if (!url) {
      return '';
    }
    // Si ya tiene protocolo https:// o http://, devolver tal cual
    if (url.match(/^https?:\/\//i)) {
      return url;
    }
    // Si no tiene protocolo, añadir https://
    return 'https://' + url;
  }

  ngOnInit() {
    
    this.catalogueService.getDataProperties().subscribe(data => {
      this.catalogueProperties = data;
    });

  }

}
